import { useEffect, useMemo, useRef } from 'react';
import useScript from '@/hooks/useScript';
import { type IEmbedTwitter } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function Twitter ({ id }: IEmbedTwitter) {
  const tweetRef = useRef(null);
  const tweetHref = useMemo(() => `https://twitter.com/user/status/${id}`, [id]);

  useScript('https://platform.twitter.com/widgets.js');
  useEffect(() => {
    if (globalThis.twttr && tweetRef.current) {
      globalThis.twttr.ready().then(() => {
        globalThis.twttr.widgets.createTweetEmbed(id, tweetRef.current);
      });
    }
  }, [tweetRef, id]);

  return (
    <blockquote className={['twitter-tweet', styles['twitter-embed']].join(' ')} ref={tweetRef}>
      <a href={tweetHref} rel='nofollow noreferrer' target='_blank'>
        {tweetHref}
      </a>
    </blockquote>
  );
}
